import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import { Button } from "../../core/components/button.js";
import { ComponentHelper } from "../../core/util/componentHelper.js"
import { SearchHelper } from "../../core/util/searchfieldHelper.js"
import { Helper } from "../../core/util/helper.js"
import React from "react";

interface SearchProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: SearchState;
    settings: any;
}



export class SearchComponent extends React.Component<SearchProps, any>{
    private multiSelect;
    private multiSelectRef;

    private searchTypeToUrl = (searchType: "address" | "machine" | "project" | "article" | "resource" | "ticket" | null) => {

        if (!Helper.hasValue(searchType) || searchType == "address") {
            return { url: "DynamicSearch/Window/Address?multi=true&displayPattern=[[adrnr]]&fullObject=true", key: "adrnr" };
        }
        else if (searchType == "machine") {
            return { url: "DynamicSearch/Window/Machine?multi=true&displayPattern=[[maschnr]]&fullObject=true", key: "maschnr" };
        }
        else if (searchType == "project") {
            return { url: "DynamicSearch/Window/Project?multi=true&displayPattern=[[projnr]]&fullObject=true", key: "projnr" };
        }
        else if (searchType == "article") {
            return { url: "DynamicSearch/Window/Article?multi=true&displayPattern=[[artnr]]&fullObject=true", key: "artnr" };
        }
        else if (searchType == "resource") {
            return { url: "DynamicSearch/Window/Resource?multi=true&displayPattern=[[ressnr]]&fullObject=true", key: "ressnr" };
        }
        else if (searchType == "ticket") {
            return { url: "DynamicSearch/Window/Procedure?multi=true&displayPattern=[[problemnr]]&fullObject=true", key: "problemnr" };
        }
    };

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.multiSelectRef);

        var select = $rootNode.kendoMultiSelect({
            autoClose: false,
            placeholder: "...",
            change: function () {
                var value = this.value();
                that.props.onTextChange(that.props.settings.name, value);
            }
        });
        this.multiSelect = select.data("kendoMultiSelect");
        this.multiSelect.input.on('keydown', this.onInputKeyPress);
        this.fillList();
    }

    onInputKeyPress = (e) => {
        if (e.key !== "Enter") {
            return;
        }
        let value: any[] = this.props.values[this.props.settings.name] ?? []
        if (value && !Array.isArray(value)) {
            value = [value];
        }
        value.push(this.multiSelect.input.val());
        this.props.onTextChange(this.props.settings.name, value);
    }

    fillList = () => {
        let value: any[] = this.props.values[this.props.settings.name] ?? []
        if (value && !Array.isArray(value)) {
            value = [value];
        }

        this.multiSelect.dataSource.data(value);
        this.multiSelect.value(value);
    }

    componentDidUpdate() {
        this.fillList();
    }

    handleOnSelect = (data) => {
        this.props.onTextChange(this.props.settings.name, data);
        this.setState({ showSearch: false });
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any[]) => {
        const fieldName = this.searchTypeToUrl(this.props.settings.searchType).key;
        if (dataItem) {
            const selectedPks = dataItem.map(x => x[fieldName]);
            this.props.onTextChange(this.props.settings.name, selectedPks);
        }
    }

    handleObjectChanged = (field: { model: string }, object: any) => {
        this.props.onTextChange(this.props.settings.name, object.Id);
    }

    handleShowSearchClicked = () => {
        const componentHelper = ComponentHelper.createFactory();
        const componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        componentSearchProps.multiSelectMode = true;
        componentSearchProps.field.searchWindowUrl = this.searchTypeToUrl(this.props.settings.searchType).url;

        if (this.props.context.openSheet) {
            this.props.context.openSheet(componentSearchProps, this.handleFieldClicked, this.handleObjectChanged, () => this.setState({ searchOpened: true }));
        }
        else {
            new SearchHelper().openSearch(componentSearchProps, this.handleFieldClicked, this.handleObjectChanged, () => this.setState({ searchOpened: true }));
        }

    }

    handleOnClose = () => {
        this.setState({ showSearch: false });
    }


    render() {

        return (
            <div>
                <react_components.ReactColumn width={this.props.metadataSettings.width}>
                    <div>
                        <react_components.TruncatedLabel>{this.props.settings.label}</react_components.TruncatedLabel>
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <select style={{ flex: "1" }} ref={(multi) => this.multiSelectRef = multi} />
                            <div style={{ marginLeft: "5px" }}>
                                <Button iconName="search" handleClick={this.handleShowSearchClicked}></Button>
                            </div>
                        </div>
                    </div>
                </react_components.ReactColumn>
            </div>
        )
    }
};

export class SearchState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private searchTypeMetadata = new propertyTypes.SelectProperty("searchType", "Search type")
        .addOption("address", "Address search")
        .addOption("resource", "Resource search")
        .addOption("machine", "Machine search")
        .addOption("project", "Project search")
        .addOption("article", "Article search")
        .addOption("ticket", "Ticket search");
    private searchType: string;

    private searchMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.searchMetadataAll = baseMetaData.concat([this.labelMetadata, this.searchTypeMetadata, this.isMandatoryMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.searchMetadataAll;
    }
}